import React from 'react';
import { AlertTriangle, AlertCircle, Link2Off } from 'lucide-react';
import { formatGreyReason } from '../../utils/formatters';

export default function GreyCardBadge({ reason, size = 'sm', showIcon = true }) {
  const info = formatGreyReason(reason);

  const icons = {
    out_of_stock: <AlertTriangle size={size === 'sm' ? 10 : 13} className="shrink-0 text-amber-300" />,
    shop_closed: <AlertCircle size={size === 'sm' ? 10 : 13} className="shrink-0 text-red-300" />,
    broken_link: <Link2Off size={size === 'sm' ? 10 : 13} className="shrink-0 text-purple-300" />
  };

  const currentIcon = icons[reason] || icons.out_of_stock;

  if (size === 'sm') {
    return (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold border backdrop-blur-md ${info.badgeBg} ${info.color}`}
        title={`Status: ${info.label}`}
      >
        {showIcon && currentIcon}
        <span>{info.label.split('/')[0].trim()}</span>
      </span>
    );
  }

  return (
    <div
      className={`flex items-center gap-2 px-2.5 py-1.5 rounded-lg border backdrop-blur-md ${info.badgeBg} ${info.color} text-xs font-medium`}
    >
      {showIcon && currentIcon}
      <span>{info.label}</span>
    </div>
  );
}
